/** @constructor */
/*
 * OSM layer tile function for google maps
 * tileSize - usu
 */
export function OSMOverlay(layer, background, tileSize) {
	this.tileSize = tileSize || new google.maps.Size(256, 256);
	this.background = background || false;
  	this.layer = layer;
}

OSMOverlay.prototype.getTile = function(coord, zoom, ownerDocument) {
	var div = ownerDocument.createElement('div');
	div.innerHTML = '<img src="https://osm.levelna.cz/tiles/'+this.layer+'/'+zoom+'/'+coord.x+'/'+coord.y+'.png" />';
	div.style.width = this.tileSize.width + 'px';
	div.style.height = this.tileSize.height + 'px';
	if (this.background) div.style.backgroundColor = 'rgba(225,225,225,0.5)'; //TODO better suppress base layer?
	return div;
};